var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccount1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.234076C6.73384 0.234076 4.0673 2.90062 4.0673 6.16683C4.0673 9.43303 6.73384 12.0996 10 12.0996C13.2663 12.0996 15.9328 9.43303 15.9328 6.16683C15.9328 2.90062 13.2663 0.234076 10 0.234076ZM10 2.18292C12.2107 2.18292 13.984 3.95621 13.984 6.16683C13.984 8.37745 12.2107 10.1507 10 10.1507C7.78943 10.1507 6.01614 8.37745 6.01614 6.16683C6.01614 3.95621 7.78943 2.18292 10 2.18292ZM3.29172 14.2341C1.79743 14.2341 0.567297 15.4642 0.567297 16.9585V17.658C0.567297 19.4185 1.6831 20.9847 3.36017 22.0542C5.0382 23.1243 7.32769 23.7662 10 23.7662C12.6724 23.7662 14.9619 23.1243 16.6399 22.0542C18.317 20.9847 19.4328 19.4185 19.4328 17.658V16.9585C19.4328 15.4642 18.2027 14.2341 16.7084 14.2341H3.29172ZM16.7084 16.1829C17.1473 16.1829 17.484 16.5196 17.484 16.9585V17.658C17.484 18.5837 16.8872 19.5851 15.5919 20.4111C14.2984 21.236 12.3583 21.8174 10 21.8174C7.64177 21.8174 5.70166 21.236 4.40816 20.4111C3.11293 19.5851 2.51614 18.5837 2.51614 17.658V16.9585C2.51614 16.5196 2.85283 16.1829 3.29172 16.1829H16.7084Z",
    fill: "#4D4D4D",
    stroke: "#4D4D4D",
    strokeWidth: 0.198841
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount1);
export default __webpack_public_path__ + "static/media/account1.9403d3e2e918dae2ed6ebf5b581cefc8.svg";
export { ForwardRef as ReactComponent };